import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { filterProps } from '../../../utils/filterProps';
import { Text } from '../../../components/Text/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const WellLabel = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(Text, Object.assign({
    typography: "heading-25",
    marginBlockEnd: "100",
    textTransform: "uppercase"
  }, domProps, tokenProps, {
    children: children
  }));
};